export default {
  searchLabel: "Please input AWB number",
  searchPlaceholder: "Input AWB number",
  dataNotFound: 'Please input AWB number',
  invalidAWB: 'AWB is not valid',
  inputOtherAWB: 'AWB number you entered is invalid, please enter another receipt number',
  logisticName: 'Logistic Name',
  service: 'Service',
  AWB: 'AWB',
  deliveredDate: 'Deliered Date',
  sender: 'Sender',
  receiver: 'Receiver'
}